<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="record-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="record-view">
                        <div class="table-head"></div>
                        <div class="table-view">
                            <vuescroll>
                                <table>
                                    <thead>
                                        <tr>
                                            <td>序号</td>
                                            <td>昵称</td>
                                            <td>神兵值</td>
                                            <td>属性</td>
                                            <td>申请时间</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in record_list" :key="index">
                                            <td style="width: 64px;">{{ (index + 1) }}</td>
                                            <td style="width: 120px;"><div class="text-overflow-1">{{ item.nickName }}</div></td>
                                            <td style="width: 88px;">{{ item.equip }}</td>
                                            <td style="width: 64px;">{{ item.back ? '回归' : '活跃'}}</td>
                                            <td class="time">{{ item.applyTime.slice(5) }}</td>
                                            <td>
                                                <div class="u-btn agree" v-if="item.review == 0" @click="apply_agree(item.code,item.nickName,item.id)"></div>
                                                <div class="u-btn dismiss" v-if="item.review == 1"></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </vuescroll>
                        </div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.record-modal{
    /* width: 728px;
    height: 638px;
    background-image: url(~@/assets/images/modal/bg-modal-record.png);   */
    width: 720px;
}

.title{
    width: 516px;
    height: 55px;
    margin: 0 auto 25px;
    background-image: url(~@/assets/images/modal/title-record.png);    
}

.table-view{
    height: 510px;
}

.table-view{
    width: 670px;
    margin-left: 0;
    font-size: 20px;
}

table{
    width: 665px;
    margin: 0 auto;
    text-align: center;
    color: #725132;
    border-collapse: collapse;
}

thead{
    td{
        font-size: 20px;
        color: #4e2612;
        background-color: #f0ecea;
    }
}

tbody td{
    height: 70px;
    border-bottom: 1px solid #f3e8d0;
}

tr{
    margin-bottom: 20px;
}

.time{
    color: #a7968f;
}

.u-btn.agree{
    width: 102px;
    height: 54px;
    background-image: url(~@/assets/images/modal/btn-agree.png);  
}

.u-btn.dismiss{
    width: 102px;
    height: 54px;
    background-image: url(~@/assets/images/modal/btn-agree_dismiss.png);  
}
</style>

<script>
import { apiApplyAgree } from '@/api/index';

export default {
    data () {
        return {
            visible : false,
            text : '',
            record_list : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        console.log(this.record_list);
    },           
    methods: {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },      
        closeModal(){
            this.destroyElement()
        },
        apply_agree(code,name,id){
            this.destroyElement();
            this.$team_agree({code : code , player_data : name , id : id});
        },       
    },    
}
</script>